import React from "react";
import "./ourValues.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "../../Layout/NavBar/NavBar";
import { GoGlobe } from "react-icons/go";
import { FaHandsHelping } from "react-icons/fa";
import { GiFreedomDove } from "react-icons/gi";
import { AiTwotoneFlag } from "react-icons/ai";
import { VscGraphLine } from "react-icons/vsc";
import { IoMdSchool } from "react-icons/io";
import { RiGlobalFill } from "react-icons/ri";

const OurValues = (props) => {
  const openMenu = props.openMenu;
  const onOpen = props.onOpen;
  const t = props.language;

  return (
    <div className="values">
      <NavBar
        language={props.language}
        languages={props.languages}
        openMenu={openMenu}
        onOpen={onOpen}
        black={true}
      />
      <div className="filler"></div>
      <div class="team__div">
        <div class="text__team">
          {t("our_values")}
          <span class="line__team"></span>
        </div>
      </div>
      <div className="values-wrap">
        <div className="value">
          <div className="value__1">
            <GoGlobe className="value--icons" />
            <h1> {t("values_1")}</h1>
            <p>{t("values_1_text")}</p>
          </div>
          <div className="value__2">
            <FaHandsHelping className="value--icons" />
            <h1> {t("values_3")}</h1>
            <p>{t("values_3_text")}</p>
          </div>
          <div className="value__3">
            <IoMdSchool className="value--icons" />
            <h1> {t("values_4")}</h1>
            <p>{t("values_4_text")}</p>
          </div>
          <div className="value__4">
            <GiFreedomDove className="value--icons" />
            <h1> {t("values_2")}</h1>
            <p>{t("values_2_text")}</p>
          </div>
          <div className="value__5">
            <AiTwotoneFlag className="value--icons" />
            <h1> {t("values_5")}</h1>
            <p>{t("values_5_text")}</p>
          </div>
          <div className="value__6">
            <VscGraphLine className="value--icons" />
            <h1> {t("values_6")}</h1>
            <p>{t("values_6_text")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurValues;
